// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__vxZmE","bigColWidth":"Table_bigColWidth__1HGob","biggerColWidth":"Table_biggerColWidth__2fY86","row":"Table_row__26S_r","col":"Table_col__kFpBw"};